import * as React from 'react';
import {
  IWeightUnitOption,
  weightUnitOptions,
} from '../../../../data/providers/settings/reports/weightReportSettingsProvider';
import { ISelectOption } from '../../../../data/types';
import { Select } from '../Select';

interface IProps {
  value: ISelectOption;
  onChange: (s: IWeightUnitOption) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * @description select control for weight units
 * @param props
 * @returns
 */
export const WeightUnitSelect = (props: IProps): React.ReactElement => {
  return (
    <Select
      style={props.style}
      name='weight-units'
      options={weightUnitOptions}
      placeholder='Mode...'
      controlShouldRenderValue
      value={props.value}
      onChange={props.onChange}
      cache={false}
      id={'weight-units-select'}
      isDisabled={props.disabled}
    />
  );
};
